//import CourseApi from '../api/mockCourseApi';
import * as types from './actionTypes';
//import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function loginUserSuccess(userLoggedIn) {
  return {type: types.LOGIN_USER_SUCCESS, userLoggedIn};
}

export function logoutUserSuccess(userLoggedIn) {
    return {type: types.LOGOUT_USER_SUCCESS, userLoggedIn};
}

// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function setUserLoggedOut() {
    return function (dispatch) {
        //dispatch(beginAjaxCall());
        return ((userLoggedIn) => {dispatch(loginUserSuccess(true))});
    };
}
export function logUserIn(userLoggedIn) {
    return function (dispatch, getState) {
        dispatch(loginUserSuccess(userLoggedIn));
    };
}

export function logUserOut(userLoggedIn) {
    return function (dispatch, getState) {
        dispatch(logoutUserSuccess(userLoggedIn));
    };
}

// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
/*
export function loadCourses() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return CourseApi.getAllCourses().then(courses => {
      dispatch(loadCoursesSuccess(courses));
    }).catch(error => {
      throw(error);
    });
  };
}

export function saveCourse(course) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return CourseApi.saveCourse(course).then(course => {
      course.id ? dispatch(updateCourseSuccess(course)) : dispatch(createCourseSuccess(course));
    }).catch(error => {
      dispatch(ajaxCallError(error));
      throw(error);
    });
  };
}
*/


// WEBPACK FOOTER //
// ./src/actions/loginActions.js